import {
  BooleanOrNullOrUndefined,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export class PlanFirstTrialStep {
  id?: number;
  plan_id?: number;
  description?: string;
  order?: number;
  accomplished?: boolean;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;

  constructor(data: Partial<PlanFirstTrialStep> = {}) {
    this.id = NumberOrNullOrUndefined(data.id);
    this.plan_id = NumberOrNullOrUndefined(data.plan_id);
    this.description = StringOrNullOrUndefined(data.description);
    this.order = NumberOrNullOrUndefined(data.order);
    this.accomplished = BooleanOrNullOrUndefined(data.accomplished);
    this.created_at = data.created_at ? new Date(data.created_at) : undefined;
    this.updated_at = data.updated_at ? new Date(data.updated_at) : undefined;
    this.deleted_at = data.deleted_at ? new Date(data.deleted_at) : undefined;
  }

  static getDefault(): PlanFirstTrialStep {
    return new PlanFirstTrialStep({
      id: undefined,
      plan_id: 0,
      description: '',
      order: 1,
      accomplished: false,
    });
  }
}
